import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos I (Derechos) y II (Obligaciones). Render condicional por cap.
// La pagina se omite cuando ambos estan off (decidido en buildPagesList).
export default function HabitantesPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verDer = !!cv.derechos;
  const verObl = !!cv.obligaciones;
  const secNum = String(pagNum - 2).padStart(2, "0");

  // Titulo dinamico segun que capitulos esten activos
  const titulo = verDer && verObl
    ? <>Derechos y <em>obligaciones</em>.</>
    : verDer ? <em>Derechos</em>
    : <em>Obligaciones</em>;

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Habitantes</span>
        <h2 className="big">{titulo}</h2>

        {verDer && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.derechos}</div>
              <h3 className="art-title">Derechos de los habitantes</h3>
            </div>
            <p className="art-lede">
              Todos los copropietarios, promitentes compradores y arrendatarios tienen derecho a exigir el cumplimiento del presente reglamento, canalizando sus reclamos a través de los órganos del edificio.
            </p>
            <div className="callout">
              <div className="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="11" x2="12" y2="17" strokeLinecap="round" />
                  <circle cx="12" cy="7.5" r="1" fill="currentColor" />
                </svg>
              </div>
              <div>
                <p className="ttl">Vía formal de reclamos</p>
                <p className="tx">
                  Los reclamos se canalizan por la <b>Comisión Administradora Honoraria</b> y, en su caso, por la Administración. No se podrá resolver directamente sin recurrir previamente a estos órganos.
                </p>
              </div>
            </div>
          </div>
        )}

        {verObl && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.obligaciones}</div>
              <h3 className="art-title">Obligaciones de los habitantes</h3>
            </div>
            <p className="art-lede">
              Todos los copropietarios, arrendatarios, parientes, ocupantes a cualquier título, proveedores y personal del edificio están obligados a:
            </p>
            <ol className="rules">
              <li><span className="m">a</span><span><b>Conservar limpieza, orden e higiene</b> de los bienes comunes y sus instalaciones, respondiendo por todo daño ocasionado.</span></li>
              <li><span className="m">b</span><span>Hacer conocer este reglamento a parientes y terceros que usen la unidad, exigiendo su cumplimiento. No podrá invocarse desconocimiento.</span></li>
              <li><span className="m">c</span><span>Los titulares mayores <b>responden plenamente por los actos de los menores</b>.</span></li>
              <li><span className="m">d</span><span>Comunicar de inmediato al Administrador cualquier daño, alteración o anormalidad.</span></li>
              <li><span className="m">e</span><span>Permitir el acceso del Administrador o personas autorizadas para reparaciones y verificaciones.</span></li>
              <li><span className="m">f</span><span>No emplear al personal del edificio en servicios personales ni darle órdenes directas.</span></li>
              <li><span className="m">g</span><span>No realizar actos que afecten la moral o alteren el orden, ni dentro de unidades privadas si trascienden al exterior.</span></li>
              <li><span className="m">h</span><span>Dar cumplimiento estricto a toda <b>disposición municipal</b>.</span></li>
              <li><span className="m">i</span><span>Avisar a la Administración en caso de venta, informando al nuevo adquirente de las obligaciones del reglamento.</span></li>
              <li><span className="m">j</span><span>Hacerse responsables por daños o perjuicios por la <b>tenencia de animales</b>.</span></li>
            </ol>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
